module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', {
    class: ("header__title header__title--" + _vm.theme)
  }, [_vm._v("\n  " + _vm._s(_vm.dataStoryTitle) + "\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4829e63c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StoryTitle.vue
// module id = 116
// module chunks = 1